
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 25 25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.75 2.5c-.688 0-1.25.563-1.25 1.25V10c0 .688-.563 1.25-1.25 1.25C.562 11.25 0 10.687 0 10V2.5C0 1.125 1.125 0 2.5 0H10c.688 0 1.25.563 1.25 1.25 0 .688-.563 1.25-1.25 1.25H3.75zm2.062 16.488l3.7-4.625a.624.624 0 01.975 0l3.225 4.025 2.038-2.725a.62.62 0 011 0L19.25 19c.312.413.012 1-.5 1H6.3a.623.623 0 01-.488-1.012zM18.75 8.125a1.872 1.872 0 00-1.875-1.875A1.872 1.872 0 0015 8.125C15 9.162 15.838 10 16.875 10a1.872 1.872 0 001.875-1.875zM15 0h7.5C23.875 0 25 1.125 25 2.5V10c0 .688-.563 1.25-1.25 1.25-.688 0-1.25-.563-1.25-1.25V3.75c0-.688-.563-1.25-1.25-1.25H15c-.688 0-1.25-.563-1.25-1.25C13.75.562 14.313 0 15 0zm7.5 21.25c0 .688-.563 1.25-1.25 1.25H15c-.688 0-1.25.563-1.25 1.25 0 .688.563 1.25 1.25 1.25h7.5c1.375 0 2.5-1.125 2.5-2.5V15c0-.688-.563-1.25-1.25-1.25-.688 0-1.25.563-1.25 1.25v6.25zM0 15c0-.688.563-1.25 1.25-1.25.688 0 1.25.563 1.25 1.25v6.25c0 .688.563 1.25 1.25 1.25H10c.688 0 1.25.563 1.25 1.25 0 .688-.563 1.25-1.25 1.25H2.5A2.507 2.507 0 010 22.5V15z","fill":"currentColor"}})])
          )
        }
      }
    